<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="productform"
          status-icon
          :model="productform"
          :rules="rules"
          label-width="120px"
          class="productInfo"
          style="width: 90%;"
        >
          <el-row>
            <el-col>
              <el-form-item label="产品编号" prop="ProductCode">
                <el-input
                  v-model="productform.ProductCode"
                  :disabled="productform.caneditProductCode"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="产品名" prop="ProductName">
                <el-input v-model="productform.ProductName" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="备注" prop="Description">
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="productform.Description"
                  maxlength="500"
                  show-word-limit
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center;">
        <el-button type="primary" @click="Onsubmit('productform')" v-if="IsEdit">提交</el-button>
        <el-button @click="OnCancel" v-if="IsEdit">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";

export default {
  name: "ProductInfoPage",
  data() {
    return {
      productform: {
        ProductCode: "",
        ProductName: "",
        caneditProductCode: false,
        Description: "",
      },
      rules: {
        ProductCode: [
          { required: true, message: "请输入产品编号", trigger: "blur" },
        ],
        ProductName: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
      },
      resData: "",
    };
  },
  props: {
    Product_Id: {
      type: String,
      default: "",
    },
    IsEdit: {
      type: Boolean,
      default: true,
    },
  },
  created: function () {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      this.GetInfo();
    },
    Onsubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SaveData();
        } else {
          this.$message({
            showClose: true,
            message: "填写内容不正确!",
            type: "error",
          });
          return false;
        }
      });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
    GetInfo() {
      this.productform.caneditProductCode = false;
      if (this.Product_Id) {
        showLoading(".zj-form-container");
        this.productform.caneditProductCode = true;

        let ProductSearch = {
          ProductId: this.Product_Id,
        };
        return new WebApis.ProductApi()
          .GetItemByProductId(ProductSearch)
          .then((res) => {
            console.log(res.data.Data);
            if (res.data.Data) {
              this.resData = res.data.Data;
              this.productform.ProductCode = this.resData.ProductCode;
              this.productform.ProductName = this.resData.ProductName;
              this.productform.Description = this.resData.Description;
              hideLoading();
            }
          })
          .catch((e) => {
            hideLoading();
            this.$message({
              showClose: true,
              message: e.RspMsg
                ? "获取产品信息失败!" + e.RspMsg
                : "获取产品信息失败!",
              type: "error",
            });
            return false;
          });
      }
    },
    SaveData() {
      let ProductDTO = {
        Id: 0,
        LogicId: "",
        ProductCode: this.productform.ProductCode,
        ProductName: this.productform.ProductName,
        OrderIndex: 0,
        Description: this.productform.Description,
        Creater: this.user.UserName,
        CreateTime: new Date(),
        Modifier: this.user.UserName,
        ModifyTime: new Date(),
        Validity: 1,
        Extend1: "",
        Extend2: "",
        Extend3: "",
      };

      if (this.resData) {
        console.log(this.resData);
        ProductDTO.Id = this.resData.Id;
        ProductDTO.LogicId = this.resData.LogicId;
        ProductDTO.Modifier = this.user.UserName;
        ProductDTO.ModifyTime = new Date();
        ProductDTO.Validity = 1;
        this.UpdateData(ProductDTO);
      } else {
        this.InsertData(ProductDTO);
      }
    },
    InsertData(ProductInfo) {
      new WebApis.ProductApi()
        .AddItem(ProductInfo)
        .then((res) => {
          if (res.RspCode == "1") {
            this.$message({
              message: "产品添加成功!",
              type: "success",
            });

            this.$emit("clickOk", {});
          } else {
            this.$message({
              showClose: true,
              message: "添加产品失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "产品添加";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "产品添加成功" : "添加产品失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "产品管理详情页面";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "添加产品失败！" + e.RspMsg : "添加产品失败！",
            type: "error",
          });
          return false;
        });
    },
    UpdateData(ProductInfo) {
      new WebApis.ProductApi()
        .UpdateItem(ProductInfo)
        .then((res) => {
          if (res.RspCode == "1") {
            this.$message({
              message: "产品修改成功!",
              type: "success",
            });

            this.$emit("clickOk", {});
          } else {
            this.$message({
              showClose: true,
              message: "修改产品失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "产品修改";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "产品修改成功" : "修改产品失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "产品管理详情页面";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "修改产品失败！" + e.RspMsg : "修改产品失败！",
            type: "error",
          });
          return false;
        });
    },
  },
};
</script>
